import { type KeyboardDownCapture } from '@canvas/input-types/keyboard-events-types';

const platform = globalThis.navigator?.platform ?? '';
const isMac = /Mac|iPhone|iPad|iPod/.test(platform);

/**
 * Matches the platform primary shortcut modifier.
 *
 * Databases follows spreadsheet conventions: command on Apple platforms and
 * control elsewhere. The helper keeps platform detection out of individual
 * keyboard handlers.
 */
export function matchesPrimaryModifier(
  event: KeyboardDownCapture['properties']['event']
): boolean {
  return isMac ? event.metaKey : event.ctrlKey;
}
